import { IFile } from "../../interfaces/IFile";
import { ISortOption } from "../../interfaces/ISortOption";
import dayjs from "dayjs";
import { FileSortOptionKeys } from "../../config/constants";
import { logger } from "../../../../utilities/logger";

export class FileSortOptionHelper {
  static sort = (files: IFile[], sortOption: ISortOption): IFile[] => {
    try {
      const sortOrderValueA: number = sortOption.sortOrder === FileSortOptionKeys.SortOrder.Ascending ? -1 : 1;
      const sortOrderValueB: number = sortOption.sortOrder === FileSortOptionKeys.SortOrder.Ascending ? 1 : -1;
  
      if (sortOption.sortField === FileSortOptionKeys.SortFields.Relevance) {
        return files.sort((a, b) => a.rank > b.rank ? sortOrderValueA : sortOrderValueB);
      }
      else if (sortOption.sortField === FileSortOptionKeys.SortFields.Size) {
        return files.sort((a, b) => a.size < b.size ? sortOrderValueA : sortOrderValueB);
      }
      else if (sortOption.sortField === FileSortOptionKeys.SortFields.TimeCreated || sortOption.sortField === FileSortOptionKeys.SortFields.TimeLastModified) {
        const sortProp: string = sortOption.sortField === FileSortOptionKeys.SortFields.TimeCreated
          ? "createdDateTime"
          : "lastModifiedDateTime";
  
          return files.sort((a, b) => dayjs(a[sortProp]) < dayjs(b[sortProp]) ? sortOrderValueA : sortOrderValueB);
      }
      else {
        let sortProp: string;
        if (sortOption.sortField === FileSortOptionKeys.SortFields.Name) {
          sortProp = "name";
        }
        else if (sortOption.sortField === FileSortOptionKeys.SortFields.Type) {
          sortProp = "fileType";
        }
  
        return files.sort((a, b) => a[sortProp]?.toUpperCase() < b[sortProp]?.toUpperCase() ? sortOrderValueA : sortOrderValueB);
      } 
    } catch (error) {
      logger(error, "FileSortOptionHelper.ts (sort)");
    }
    return files;
  }
}